/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { SeizurePeriodDto } from './seizure-period-dto';

/**
 * 
 * @export
 * @interface RecentSeizuresDto
 */
export interface RecentSeizuresDto {
    /**
     * 
     * @type {number}
     * @memberof RecentSeizuresDto
     */
    'count'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RecentSeizuresDto
     */
    'countable'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof RecentSeizuresDto
     */
    'dates': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof RecentSeizuresDto
     */
    'datesAreKnown': boolean;
    /**
     * 
     * @type {number}
     * @memberof RecentSeizuresDto
     */
    'frequency'?: number;
    /**
     * 
     * @type {string}
     * @memberof RecentSeizuresDto
     */
    'frequencyPeriod'?: RecentSeizuresDtoFrequencyPeriodEnum;
    /**
     * 
     * @type {Array<SeizurePeriodDto>}
     * @memberof RecentSeizuresDto
     */
    'periodicEpisodes': Array<SeizurePeriodDto>;
    /**
     * 
     * @type {boolean}
     * @memberof RecentSeizuresDto
     */
    'regularOccurrence'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum RecentSeizuresDtoFrequencyPeriodEnum {
    Year = 'YEAR',
    Month = 'MONTH',
    Day = 'DAY'
}


